/*
ajax请求函数模块
返回值: promise对象(异步返回的数据是: response.data)
*/
import axios from 'axios'
// import md5 from 'js-md5'
export default function ajax (url, data={}, type='GET') {

  return new Promise(function (resolve, reject) {
    // 执行异步ajax请求
    let promise
    if (type === 'GET') {
      // 准备url query参数数据
      let dataStr = '' //数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&'
      })
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
      // 发送get请求
      promise = axios.get(url)
    } else {

      axios.defaults.headers = {
          'Content-type': 'application/x-www-form-urlencoded'
      }   
      // 发送post请求
      promise = axios.post(url, data)
    }
    promise.then(function (response) {
      // 成功了调用resolve()
      resolve(response.data)
    }).catch(function (error) {
      //失败了调用reject()
      reject(error)
    })
  })
}

/*
// let appid = 'tecadmin';
    // let timestamp = parseInt(Date.now());

    //签名参数signature通过
    //appid、secret、timestamp三个值连接为一个字符串,然后进行双层md5加密生成;
    // let secret ='1234abcd';
    // let signature = appid + secret + timestamp;

    // console.log(signature)
    // signature = md5(md5(signature))
    // console.log(signature)
    // let timestamp = Date.parse()
    //1234@abcd
    // let data = {
    //     appid,
    //     timestamp,
    //     signature
    // }
    // axios.post(url,data)
    axios.post(url)
    console.log(123)
 */



// WEBPACK FOOTER //
// ./src/api/ajax.js